import Instance from "../../../../Axios";

// New Actions for the app

const GetCredFuncionariosUploadedFiles = (funcionarioId) => async (dispatch) => {
  await Instance()
    .get(`/credenciacoes/funcionarios/${funcionarioId}/files`)
    .then(({ data }) => {
      dispatch({
        type: "GET_CRED_FUNCIONARIOS_UPLOADED_FILES",
        payload: data.yData,
      });
    })
    .catch((err) => {
      console.log(err);
    });
};

export default GetCredFuncionariosUploadedFiles;